// Stable page identifiers shared by web, mobile and the future CSM portal. A value here is a
// contract with the other platforms: rename it and an existing announcement stops matching.
enum AnnouncementPageId {
  ACTIVITIES = "activities",
  ACTIVITIES_CALENDAR = "activities-calendar",
  ACTIVITIES_LIST = "activities-list",
  ACTIVITIES_RECORD = "activities-record",
  ACTIVITIES_SCHEDULER = "activities-scheduler",
  BILLING = "billing",
  COMPANIES = "companies",
  COMPANIES_RECORD = "companies-record",
  DASHBOARD = "dashboard",
  DASHBOARD_COACHING = "dashboard-coaching",
  DASHBOARD_EXECUTIVE_SUMMARY = "dashboard-executive-summary",
  DASHBOARD_TASKS = "dashboard-tasks",
  DASHBOARD_TIMELINE = "dashboard-timeline",
  DEALS = "deals",
  DEALS_FORECAST = "deals-forecast",
  DEALS_KANBAN = "deals-kanban",
  DEALS_LIST = "deals-list",
  DEALS_RECORD = "deals-record",
  EMAIL_OUTBOX = "email-outbox",
  FILES = "files",
  MAP = "map",
  MAP_GROUPS = "map-groups",
  MAP_LEADS = "map-leads",
  MAP_TERRITORIES = "map-territories",
  NOTIFICATIONS = "notifications",
  ONBOARDING = "onboarding",
  ONBOARDING_GUIDES = "onboarding-guides",
  ONBOARDING_MY = "onboarding-my",
  ONBOARDING_USERS = "onboarding-users",
  PEOPLE = "people",
  PEOPLE_RECORD = "people-record",
  REPORTS = "reports",
  REPORTS_ACTIVITY = "reports-activity",
  REPORTS_DASHBOARDS = "reports-dashboards",
  REPORTS_DEALS = "reports-deals",
  REPORTS_EMAIL_ACTIVITY = "reports-email-activity",
  REPORTS_EXPORTS = "reports-exports",
  REPORTS_MILEAGE_TRACKING = "reports-mileage-tracking",
  REPORTS_OVERVIEW = "reports-overview",
  REPORTS_REPORT_CARD = "reports-report-card",
  REPORTS_STACK_RANK = "reports-stack-rank",
  RESOURCES = "resources",
  ROUTES = "routes",
  ROUTES_EDIT = "routes-edit",
  ROUTES_LIST = "routes-list",
  ROUTES_UPCOMING = "routes-upcoming",
  ROUTES_VIEW = "routes-view",
  SETTINGS = "settings",
  SETTINGS_DATA = "settings-data",
  SETTINGS_DATA_IMPORT_HISTORY = "settings-data-import-history",
  SETTINGS_DATA_NEW_IMPORT = "settings-data-new-import",
  SETTINGS_DATA_RESTORABLE_RECORDS = "settings-data-restorable-records",
  SETTINGS_FORMS = "settings-forms",
  SETTINGS_FORMS_CREATE_FORMS = "settings-forms-create-forms",
  SETTINGS_FORMS_FILE_TAGS = "settings-forms-file-tags",
  SETTINGS_FORMS_MANAGE_FIELDS = "settings-forms-manage-fields",
  SETTINGS_FORMS_MERGE_DUPLICATES = "settings-forms-merge-duplicates",
  SETTINGS_FORMS_PINNED_FIELDS = "settings-forms-pinned-fields",
  SETTINGS_ORGANIZATION = "settings-organization",
  SETTINGS_ORGANIZATION_ACTIVITY_TYPES = "settings-organization-activity-types",
  SETTINGS_ORGANIZATION_DETAILS = "settings-organization-details",
  SETTINGS_ORGANIZATION_FEATURES = "settings-organization-features",
  SETTINGS_ORGANIZATION_INTEGRATIONS = "settings-organization-integrations",
  SETTINGS_ORGANIZATION_SANDBOX = "settings-organization-sandbox",
  SETTINGS_PERSONAL = "settings-personal",
  SETTINGS_PERSONAL_CALENDAR_SYNC = "settings-personal-calendar-sync",
  SETTINGS_PERSONAL_EMAIL_PREFERENCES = "settings-personal-email-preferences",
  SETTINGS_PERSONAL_PROFILE = "settings-personal-profile",
  SETTINGS_PERSONAL_SESSIONS = "settings-personal-sessions",
  SETTINGS_PRIVACY = "settings-privacy",
  SETTINGS_PRIVACY_NOTIFICATIONS = "settings-privacy-notifications",
}

export default AnnouncementPageId;
